<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    /*
        Wrapper around ElementEditor so that it can be used stand-alone (instead of coupled with a SequenceList like
        in the Content Editor's ElementEditTab).
     */
    import {onMount} from 'svelte';
    import {get, post, secondToHour, submit} from '../../utils.js';
    import ElementEditor from './ElementEditor.svelte'
    import Workspaces from '../Workspaces/Workspaces.svelte'
    import {
        draftElementDetails,
        elementDetails,
        elementInstance,
        elementTypes,
        loadingElementDetails,
        location,
        branchId,
        standaloneEdit,
        readOnly,
    } from '../Workspaces/workspacesStore.js';
    import {elementTabs} from '../Workspaces/tabStore.js';
    import ElementContent from '../Workspaces/ElementView/ElementContent.svelte';
    import {setActiveTab, toggleTabHide} from '../TabView/TabView.svelte';
    import {sgettext} from '../../i18n.js';
    import {TabView, Tab, TabList, TabPanel} from '../common/Tab/tabs.js';
    import ElementViewTab from '../Workspaces/ElementViewTab.svelte';
    import ElementIssuesTab from '../Workspaces/ElementIssuesTab.svelte';
    import ElementEditTab from '../Workspaces/ElementEditTab.svelte';
    import MaterialRiskTab from '../Workspaces/MaterialRiskTab.svelte';
    import UsageTab from '../Workspaces/UsageTab.svelte';
    import VersionsTab from '../Workspaces/VersionsTab.svelte';

    export let elementId = 0;
    export let branch = {'id': 1, 'full_name': '/BHP'};
    export let read_only = false;
    export let elementFromAPM = false;
    export let display_as_aies = false;
    let draftElementVersionViewApiUrl = `${PATH_PREFIX}/sw/api/elements_database/draft_element_version/`;
    let elementApiUrl = `${PATH_PREFIX}/sw/api/elements_database/elements/`;
    let isSafetyElement;
    let elementIsArchived;

    $: if ($elementDetails) {
        isSafetyElement = $elementDetails.type === 'SAFETY';
        elementIsArchived = $elementDetails.archived;
    } else {
        isSafetyElement = false;
        elementIsArchived = false;
    }
    elementTabs.set([
        {
            key: 'view',
            label: sgettext('$$VIEW_CURRENT$$'),
            active: true,
            content: ElementViewTab
        },
        {
            key: 'edit',
            label: sgettext('$$EDIT_DRAFT$$'),
            content: ElementEditTab,
            hide: true,
            elementFromAPM: {elementFromAPM},
            display_as_aies:display_as_aies
        },
        {
            key: 'material_risk',
            label: sgettext('$$MATERIAL_RISK$$'),
            content: MaterialRiskTab,
            hide: true,
        },
        {
            key: 'versions',
            label: sgettext('$$VERSIONS$$'),
            content: VersionsTab,
            hide: true,
        },
        {
            key: 'usage',
            label: sgettext('$$RELATED_USE$$'),
            content: UsageTab,
            hide: true,
        },
        {
            key: 'issues',
            label: sgettext('$$IMPROVEMENTS$$'),
            content: ElementIssuesTab,
            hide: true,
        }
    ]);


    $: if (elementId === 0) {
        initialiseNewElement();
    }

    $: if ($elementDetails && $elementDetails.type === 'SAFETY') {
        elementTabs.set(toggleTabHide('material_risk', $draftElementDetails === null, $elementTabs));
    } else {
        elementTabs.set(toggleTabHide('material_risk', true, $elementTabs));
    }

    $: if ($elementDetails) {
        elementTabs.set(toggleTabHide('edit', elementIsArchived || read_only || (!display_as_aies && $elementDetails.ev_inspection_element=="Asset Integrity"), $elementTabs));
        elementTabs.set(toggleTabHide('versions', false, $elementTabs));
        elementTabs.set(toggleTabHide('usage', false, $elementTabs));
        elementTabs.set(toggleTabHide('issues', false, $elementTabs));
    } else {
        elementTabs.set(toggleTabHide('edit', true, $elementTabs));
        elementTabs.set(toggleTabHide('versions', true, $elementTabs));
        elementTabs.set(toggleTabHide('usage', true, $elementTabs));
        elementTabs.set(toggleTabHide('issues', true, $elementTabs));
    }


    function initialDraftElementVersion() {
        return {
            competencies: [],
            eevId: 0,
            elementId: 0,
            evId: 0,
            hazardscontrols: [],
            keypoints: [],
            location: $location,
            global_hazard: null,
            global_control: null,
            mainMedia: null,
            name: '',
            questions: [],
            reportingGroups: [],
            tags: [],
            time: 0,
            torch: false,
            type: null,
            version: 0,
            warnings: [],
        };
    }

    function initialiseNewElement() {
        // elementInstance.set({
        //     id: 0,
        //     name: '',
        //     worksequenceId: 0,
        //     roleId: 0,
        //     versions: [],
        //     index: 0,
        // });

        // elementDetails.set(null);
        draftElementDetails.set(initialDraftElementVersion());
        elementTabs.set(setActiveTab('edit', $elementTabs));
        setTimeout(() => {
            jQuery(`#name`).focus();
        }, 100);
    }

    async function getElementDetails() {
        if (elementId > 0) {
            loadingElementDetails.set(true);
            const url = `${elementApiUrl}${elementId}/element_detail/`;

            const response = await get(url);
            if (response.ok) {
                let updated = await response.json();
                elementDetails.update(_ => updated);
            }
            loadingElementDetails.set(false);
        }

        // TODO
        elementInstance.set({
            id: 0,
            name: '',
            worksequenceId: 0,
            roleId: 0,
            versions: [],
            index: 0,
            type: '',
            action_id:''
        });
    }

    async function getIssuesCount() {
        const eevId = $elementDetails ? $elementDetails.eevId : 0;

        if (eevId) {
            const issuesResponse = await get(`${PATH_PREFIX}/sw/api/elements_database/element_version/${eevId}/element-issues/`);
            if (issuesResponse.ok) {
                const issues = await issuesResponse.json();
                const activeTab = $elementTabs.find(t => t.key === 'issues');
                const numOpenIssues = issues.filter(x => x.status === 'OPEN').length;
                activeTab.label = `${sgettext('$$IMPROVEMENTS$$')} (${numOpenIssues})`
                elementTabs.set([...$elementTabs]);
            }
        }
    }

    function activateTabFromUrlHash() {
        if (window.location.hash) {
            try {
                elementTabs.set(setActiveTab(window.location.hash.substr(1), $elementTabs));
            } catch (_) {}
        }
    }

    onMount(async () => {
        standaloneEdit.set(true);
        readOnly.set(read_only);
        branchId.set(branch.id);
        location.set(branch.full_name);
        await getElementDetails();
        getIssuesCount();
        activateTabFromUrlHash();
    });
</script>

<ElementContent elementFromAPM={elementFromAPM}/>
